export default "__VITE_ASSET__CuNbvvXT__"